



































import { Component, Prop, Vue } from "vue-property-decorator";
import VDraggableList from "@/components/VDraggableList.vue";
import VDraggableListItem from "@/components/VDraggableListItem.vue";
import { ServiceEstimatePaymentMethodRow } from "@/api/project/estimate-payment-method-api";

@Component({
  components: {
    VDraggableList,
    VDraggableListItem
  }
})
export default class EstimatePaymentMethodTable extends Vue {
  @Prop({ required: true }) items!: ServiceEstimatePaymentMethodRow[];

  fields = [
    { key: "name", label: "お⽀払い⽅法" },
    { key: "actions", label: "" }
  ];

  canDelete(item: ServiceEstimatePaymentMethodRow): boolean {
    return item.name !== "現金・振込";
  }

  async deleteItem(id: number) {
    if (!confirm("この項目を削除してもよろしいですか？")) {
      return;
    }
    this.$emit("remove", id);
  }

  sort(keys: ServiceEstimatePaymentMethodRow[]) {
    this.$emit("sort", keys);
  }
}
